import { render } from "./SquareArrowButton.vue?vue&type=template&id=7a4705e0"
import script from "./SquareArrowButton.js?vue&type=script&lang=js"
export * from "./SquareArrowButton.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__